function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Children } from "react";
import { node, string, bool, func } from "prop-types";
import { Modal } from "#library/components/Modal/Modal";
import { Accordion } from "#library/components/MenuBar/Accordion/Accordion";
import { ModalLink } from "#library/components/MenuBar/Link/ModalLink";
import { MODAL_CHILDREN_ITEMS } from "#library/components/MenuBar/constants";
import styles from "./menuBarModal.module.css";
export var MenuBarModal = function MenuBarModal(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    title = _ref.title,
    onClose = _ref.onClose,
    children = _ref.children;
  if (!isOpen) {
    return null;
  }
  var _onClick = function onClick(item) {
    if (item.props.onClick) {
      item.props.onClick();
    }
    if (onClose) {
      onClose();
    }
  };
  var content = Children.map(children, function (child, index) {
    var childName = child.type.name;
    if (childName === MODAL_CHILDREN_ITEMS.LINK) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("li", {
          key: index,
          className: styles["jds-MenuBarModal__listItem"]
        }, /*#__PURE__*/React.createElement(ModalLink, _extends({}, child.props, {
          className: styles["jds-MenuBarModal__button"],
          onClick: function onClick() {
            return _onClick(child);
          }
        })))
      );
    }
    if (childName === MODAL_CHILDREN_ITEMS.DROPDOWN) {
      var _child$props$children = _slicedToArray(child.props.children, 2),
        label = _child$props$children[0].props.children,
        itemsChildren = _child$props$children[1].props.children;
      var items = itemsChildren.map(function (item) {
        return /*#__PURE__*/React.cloneElement(item, {
          onClick: function onClick() {
            return _onClick(item);
          }
        });
      });
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("li", {
          key: index,
          className: styles["jds-MenuBarModal__listItem"]
        }, /*#__PURE__*/React.createElement(Accordion, {
          items: items
        }, label))
      );
    }
    return null;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Modal.Title, null, title)), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("ul", {
    className: styles["jds-MenuBarModal__list"]
  }, content)));
};
MenuBarModal.propTypes = {
  children: node.isRequired,
  isOpen: bool,
  title: string.isRequired,
  onClose: func
};